import { colors } from '@/constants';
import styled from 'styled-components';

export type CardColor = 'success' | 'danger' | 'warning' | 'default';

export const Card = styled.div<{ $themecolor?: CardColor }>`
  padding: 15px;
  background-color: ${colors.brand.white};
  border-radius: 6px;
  border: 1px solid ${colors.gray.gray10};
  margin-bottom: 10px;
  box-shadow: 0px 4px 10px 0px ${colors.shadown6};
`;

export const Content = styled.div`
  overflow-y: auto;
  max-height: 500px;
  background-color: ${colors.gray.gray0};
`;

export const Header = styled.div`
  height: 60px;
  position: relative;
  z-index: 999;
  box-shadow: 0px 4px 10px 0px ${colors.shadown6};
`;

export const Scrollable = styled.div`
  overflow-y: auto;
  max-height: 420px;
  padding: 20px 15px 20px 15px;
`;

export const Row = styled.div<{ $borderBottom?: boolean; $bgColor?: boolean; $justify?: 'center' | 'none'; $gap?: number }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: ${({ $justify }) => $justify || 'space-between'};
  padding: 15px 10px;
  border-radius: ${({ $bgColor }) => ($bgColor ? '6px' : '0px')};
  border-bottom: ${({ $borderBottom }) => ($borderBottom ? `1px solid ${colors.gray.gray10}` : 'none')};
  background-color: ${({ $bgColor }) => ($bgColor ? colors.gray.gray10 : 'transparent')};
  gap: ${({ $gap }) => $gap || 0}px;
`;

const colorsStatus = {
  PAGO: colors.alert.green110,
  VENCIDO: colors.alert.red200,
  PENDENTE: colors.alert.orange300,
};

export const Label = styled.span<{ $color?: keyof typeof colorsStatus; $weight?: number; $size?: number; $pl?: number }>`
  font-size: ${({ $size }) => $size || 14}px;
  font-weight: ${({ $weight }) => $weight || 400};
  padding-left: ${({ $pl }) => $pl || 0}px;
  color: ${({ $color }) => ($color ? colorsStatus[$color] : colors.brand.grafite)};
`;

const colorsTag = {
  PAGO: colors.alert.green50,
  VENCIDO: colors.alert.red50,
  ABERTO: colors.alert.orange50,
};

export const Tag = styled.div<{ $color: keyof typeof colorsTag }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 7px 13px;
  border-radius: 4px;
  background-color: ${({ $color }) => ($color ? colorsTag[$color] : colors.gray.gray10)};
`;
